module.exports = __webpack_public_path__ + "media/images/pc/articles/recommend_temp_02-0f5e27e09b31448e82b6d51360b32bf5.webp";